import type { TOC } from '@ember/component/template-only';
import { PrismLoadingBar } from '@mylighthouse/prism-ember';
import GeneralPageHeader from 'lumen/components/general/page/header';
import GeneralPageMain from 'lumen/components/general/page/main';
import {
  HEADER_HEIGHT,
  SUB_HEADER_HEIGHT,
} from 'lumen/utils/constants/general-constants';

const LOADING_BAR_POSITION = HEADER_HEIGHT + SUB_HEADER_HEIGHT;

interface ParityInsightLayoutSignature {
  Args: {
    isLoading: boolean;
  };
  Blocks: {
    breakdown: [];
    default: [];
    evolution: [];
    header: [];
    kpiHeader: [];
    subHeader: [];
  };
  Element: HTMLDivElement;
}

/* `...attributes` lands on GeneralPageMain (#main-content-wrapper-target), so
   modifiers passed to <ParityInsightLayout> run on the page's scroll container. */
const ParityInsightLayout = <template>
  <GeneralPageHeader>
    <div class="content-wrapper flex items-center">
      {{yield to="header"}}
    </div>
  </GeneralPageHeader>

  <GeneralPageHeader @isSmall={{true}}>
    <div class="content-wrapper flex items-center">
      {{yield to="subHeader"}}
    </div>
  </GeneralPageHeader>

  {{yield to="kpiHeader"}}

  <GeneralPageMain ...attributes>
    {{#if @isLoading}}
      <PrismLoadingBar
        @isFixed={{true}}
        @positionTop={{LOADING_BAR_POSITION}}
      />
    {{/if}}

    <div class="content-wrapper main-content grid gap-800">
      <section class="grid gap-400">
        {{yield to="evolution"}}
      </section>

      <section class="grid gap-400">
        {{yield to="breakdown"}}
      </section>

      {{yield}}
    </div>
  </GeneralPageMain>
</template> satisfies TOC<ParityInsightLayoutSignature>;

export default ParityInsightLayout;
